import { render, staticRenderFns } from "./CustomerProposals.vue?vue&type=template&id=68a29993"
import script from "./CustomerProposals.vue?vue&type=script&lang=js"
export * from "./CustomerProposals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports